import { Coffee, Utensils, UtensilsCrossed, Sparkles, Home, Ban, LucideIcon } from "lucide-react";

export function getBoardTypeIcon(boardType: string | undefined): LucideIcon {
  if (!boardType) return Home;
  
  const normalized = boardType.toLowerCase().trim();
  
  // Map board types to icons
  if (normalized.includes("todo incluido")) return Sparkles;
  if (normalized.includes("pensión completa")) return Utensils;
  if (normalized.includes("media pensión")) return UtensilsCrossed;
  if (normalized.includes("desayuno")) {
    if (normalized.includes("sin desayuno")) return Ban;
    return Coffee;
  }
  if (normalized.includes("sin comidas") || normalized.includes("solo alojamiento")) return Home;
  
  return Home;
}

export function getBoardTypeColor(boardType: string | undefined): string {
  if (!boardType) return "text-muted-foreground";
  
  const normalized = boardType.toLowerCase().trim();
  
  // Map board types to colors
  if (normalized.includes("todo incluido")) return "text-purple-600 dark:text-purple-400";
  if (normalized.includes("pensión completa")) return "text-green-600 dark:text-green-400";
  if (normalized.includes("media pensión")) return "text-blue-600 dark:text-blue-400";
  if (normalized.includes("desayuno")) {
    if (normalized.includes("sin desayuno")) return "text-red-600 dark:text-red-400";
    return "text-amber-600 dark:text-amber-400";
  }
  if (normalized.includes("sin comidas") || normalized.includes("solo alojamiento")) return "text-slate-600 dark:text-slate-400";
  
  return "text-muted-foreground";
}

export function getBoardTypeBadgeStyle(boardType: string | undefined): string {
  if (!boardType) return "bg-muted/50 text-muted-foreground border-muted";
  
  const normalized = boardType.toLowerCase().trim();
  
  // Map board types to badge styles with background colors
  if (normalized.includes("todo incluido")) 
    return "bg-purple-500/10 text-purple-700 dark:text-purple-300 border-purple-500/20";
  if (normalized.includes("pensión completa")) 
    return "bg-green-500/10 text-green-700 dark:text-green-300 border-green-500/20";
  if (normalized.includes("media pensión")) 
    return "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/20";
  if (normalized.includes("desayuno")) {
    if (normalized.includes("sin desayuno")) 
      return "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20";
    return "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20";
  }
  if (normalized.includes("sin comidas") || normalized.includes("solo alojamiento")) 
    return "bg-slate-500/10 text-slate-700 dark:text-slate-300 border-slate-500/20";
  
  return "bg-muted/50 text-muted-foreground border-muted";
}
